import {
  CircleCheckIcon,
  CloseCircleIcon,
  RunningIcon,
  CircleQuestionIcon,
  StateBlockedIcon,
  type Icon,
} from '@tanium/react-graphics';
import { InstanceStatus } from '../types';

const COLOR_GREEN = 'green';
const COLOR_GRAY = 'gray';
// Matches the blue already used for the "Available" pending-offer icon on the instances table.
const COLOR_BLUE = '#006FCC';

export function instanceStatusDisplay(status: InstanceStatus | undefined): {
  StatusGlyph: Icon;
  iconColor: string;
  text: string;
} {
  if (status === undefined) {
    return { StatusGlyph: CircleQuestionIcon, iconColor: COLOR_GRAY, text: 'Unknown' };
  }
  switch (status) {
    case InstanceStatus.Active:
      return { StatusGlyph: CircleCheckIcon, iconColor: COLOR_GREEN, text: status };
    // Licensed: downloaded but not onboarded, so a blue check rather than the green "it's up".
    case InstanceStatus.Licensed:
      return { StatusGlyph: CircleCheckIcon, iconColor: COLOR_BLUE, text: status };
    case InstanceStatus.Creating:
    case InstanceStatus.Reactivating:
      return { StatusGlyph: RunningIcon, iconColor: COLOR_GREEN, text: status };
    case InstanceStatus.Deactivating:
    case InstanceStatus.Deleting:
      return { StatusGlyph: RunningIcon, iconColor: COLOR_GRAY, text: status };
    case InstanceStatus.Deactivated:
      return { StatusGlyph: StateBlockedIcon, iconColor: COLOR_GRAY, text: status };
    case InstanceStatus.Deleted:
      return { StatusGlyph: CloseCircleIcon, iconColor: COLOR_GRAY, text: status };
    case InstanceStatus.Unknown:
      return { StatusGlyph: CircleQuestionIcon, iconColor: COLOR_GRAY, text: status };
    default:
      return { StatusGlyph: CircleQuestionIcon, iconColor: COLOR_GRAY, text: String(status) };
  }
}
